import { NbtFile } from './nbt/NbtFile.js'
import { litematicToStructure } from './Litematic.js'
import type { NbtCompound } from './nbt/tags/NbtCompound.js'

export { StructureRenderer } from './StructureRenderer.js'
export type { Resources } from './StructureRenderer.js'
export { createCameraPixelRay, rayTraceMeshes } from './RayTrace.js'
export type { CameraPixelRayViewMetadata, RayTraceHit, RayTraceRay, RayTraceVec3 } from './RayTrace.js'
export { Structure } from './Structure.js'
export type { PlacedBlock } from './Structure.js'
export { MultiStructure } from './MultiStructure.js'
export type { StructureRegion } from './MultiStructure.js'
export { NbtFile } from './nbt/NbtFile.js'
export type { NbtCompressionMode, NbtCreateOptions } from './nbt/NbtFile.js'
export type { StructureProvider } from './core/StructureProvider.js'
export type { BlockPos } from './core/BlockPos.js'
export type { JsonValue } from './util/index.js'

export interface LoadLitematicOptions {
	limit?: number
}

export function loadLitematic(data: Uint8Array | ArrayBuffer, options: LoadLitematicOptions = {}) {
	const bytes = data instanceof Uint8Array ? data : new Uint8Array(data)
	return loadLitematicFromNbt(NbtFile.read(bytes), options)
}

export function loadLitematicFromNbt(file: NbtFile | NbtCompound, options: LoadLitematicOptions = {}) {
	const root = file instanceof NbtFile ? file.root : file
	if (!root.hasCompound('Regions')) {
		throw new Error('Expected a .litematic file with a Regions compound.')
	}
	return litematicToStructure(root, options.limit)
}
